import { messageModel } from 'APP/model/model';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { GroupsEvent } from '../GroupsEvent';

export class DraftWasUpdated extends GroupsEvent {
  async process() {
    const { draftId, groupId } = this.eventPayload;
    let draft = null;
    try {
      draft = await messageModel.getDraft({
        groupId: groupId.toString(),
        draftId: draftId.toString(),
      });
    } catch {
      //
    }

    if (!draft) {
      return;
    }

    const group = Entities.GroupsStore.getGroupById(groupId.toString());

    if (!group) {
      return;
    }

    const targetDraft = group.draftsStore.getDraftById(draft.id);
    const chatDraft = new ChatMessage(draft, group.messagesStore);

    if (!targetDraft) {
      group.draftsStore.setDraft(chatDraft);

      return;
    }

    group.draftsStore.updateDraft(chatDraft);
  }
}
